module.exports = __webpack_public_path__ + "img/hsi.58aaf5d3.png";